import script from "./InvestmentCostsView.vue?vue&type=script&setup=true&lang=js"
export * from "./InvestmentCostsView.vue?vue&type=script&setup=true&lang=js"

import "./InvestmentCostsView.vue?vue&type=style&index=0&id=3ad658ba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ad658ba"]])

export default __exports__